import React, { useState } from 'react';
import './index.scss';
import { ButtonLink, Icon, Line } from 'dyl-components';
import { Grid, GridColumn } from 'semantic-ui-react';

const OfficeViewAdditionalLines = ({ height = 120, lines = [], currentTime , onSelectCall, onUnholdCall, onAnswer, onReject, onTransferCall, answerDisabled}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const additionalLineHeight = height === "scroll" ? { style: { overflowY: "scroll", height: 296 } } : { style: { height } };
    return (
        <div style={{ height: 30, width: "100%", position: 'relative', overflow: "visible" }}>
            <div 
                className={`OfficeView__additionalLines ${isExpanded ? "OfficeView__additionalLines--expanded" : ""}`}
                {...(isExpanded && additionalLineHeight)}
            >
                <span style={{ flex: 1 }}>Additional Lines</span>
                <ButtonLink style={{float: 'right', ...(!isExpanded && { marginTop: 6 })}} onClick={ () => setIsExpanded((prevValue) => !prevValue) }>
                    <Icon className={`fa-solid fa-circle-chevron-${isExpanded ? "down" : "up"}`} />
                </ButtonLink>
                {isExpanded && (
                    <Grid style={{marginTop: 1}}>
                        {lines.map((line) => {
                        return(
                            <>
                                <GridColumn width={8}>
                                    <Line 
                                        line={line}
                                        currentTime={currentTime}
                                        onSelectCall={onSelectCall}
                                        onUnholdCall={onUnholdCall}
                                        onAnswer={onAnswer}
                                        onReject={onReject}
                                        onTransferCall={onTransferCall}
                                        answerDisabled={answerDisabled}
                                    />
                                </GridColumn>                                 
                            </>
                        )})}
                    </Grid>
                )}
            </div>
        </div>
    )
}

export default OfficeViewAdditionalLines;

